import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import styles from './AcknowledgmentActionDialog.module.scss'

type AcknowledgmentDeleteDialogProps = {
  show: boolean
  onClose: () => void
  onConfirm: () => void
}

export const AcknowledgmentDeleteDialog = ({
  show,
  onClose,
  onConfirm,
}: AcknowledgmentDeleteDialogProps) => {
  return (
    <ModalDialog
      closeOnOutsideClick={false}
      show={show}
      size="xs"
      classes={{
        window: styles.window,
        body: styles.body,
      }}
      header={() => (
        <div className={styles.dialogHeader}>
          <div className={styles.title}>
            <Translation text="jbp-commitment-delete-dialog-title" />
          </div>
        </div>
      )}
      content={() => (
        <div className={styles.root}>
          <p className={`${styles.description} ${styles.descriptionLeft}`}>
            <Translation text="jbp-commitment-delete-dialog" />
          </p>

          <div className={styles.buttonLine}>
            <Button className={styles.button} color="grey" onClick={onClose}>
              <Translation text="jbp-commitment-delete-dialog-cancel" span />
            </Button>
            <Button className={styles.button} color="danger" onClick={onConfirm}>
              <Translation text="jbp-commitment-delete-dialog-delete" span />
            </Button>
          </div>
        </div>
      )}
      onClose={onClose}
    />
  )
}
